
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import React, { useEffect, useState, useCallback } from "react";
import { usePostApi } from "../../hooks/post_api_hook/usePostApi";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../../utils/confserveur";
import { useClasseContext } from "../../context/ClasseContext";
import { GripVertical, TrendingUp, TrendingDown, Activity, Brain, Puzzle, BookOpen, ChevronRight, ArrowRightLeft, CheckSquare, Lock, Sparkles, Users, Eye, EyeOff, ArrowUpAZ, ArrowDownWideNarrow, Loader2, Download } from "lucide-react";
import * as XLSX from 'xlsx';
import useConfirm from "../../hooks/ui/useConfirm";
function VisuelGroupe ({elevesParCluster , selectedAutomatismes, selectedProblemes, labelAutomatismes, labelProblèmes , 
  selectedLexique, selectedComprehension,
            labelLexiqueNat, labelComprehensionEcriteNat,
             selectedCompetences, labelCompetencesLangagieresNat,
  listGroupes, eleves, selectedEvalClasse, selectedBarette , setIsSubmit, conservationMode}) {
   

    
    // Ajouter ces états au composant principal
const [selectionMode, setSelectionMode] = useState(false);
const [selectedStudents, setSelectedStudents] = useState(new Set());
  // Fonction pour nettoyer les doublons GLOBALEMENT entre tous les clusters
  const cleanDuplicatesInClusters = (clustersObj) => {
    const cleaned = {};
    const globalSeen = new Set(); // Set global pour tracker tous les élèves déjà vus

    Object.keys(clustersObj).forEach(clusterKey => {
      const elevesArray = clustersObj[clusterKey];
      cleaned[clusterKey] = elevesArray.filter(eleve => {
        if (globalSeen.has(eleve.id)) {
          console.warn(`🚨 Duplicate GLOBAL removed from cluster ${clusterKey}: ${eleve.nom} ${eleve.prenom} (ID: ${eleve.id}) - Already in another cluster`);
          return false; // Retire le doublon car déjà vu dans un autre cluster
        }
        globalSeen.add(eleve.id);
        return true; // Garde la première occurrence globale
      });
    });

    return cleaned;
  };

  const [clusters, setClusters] = useState(() => {
    if (conservationMode) {
      const remapped = {};
      Object.entries(elevesParCluster).forEach(([clusterId, eleves]) => {
        const groupe = listGroupes.find(g =>
          g.id === parseInt(clusterId) || g.nom === clusterId
        );
        remapped[groupe ? groupe.id : clusterId] = eleves;
      });
      return cleanDuplicatesInClusters(remapped);
    }
    return cleanDuplicatesInClusters(elevesParCluster);
  });
  const [showDetails, setShowDetails] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [sortMode, setSortMode] = useState('default'); // 'default', 'name', 'score-asc', 'score-desc'
  // Modifications MANUELLES (drags, sélection multiple, attributions) : le
  // bouton RETOUR les perdrait sans bruit — on demande confirmation si vrai.
  const [modifsManuelles, setModifsManuelles] = useState(false);
  const { confirm, ConfirmDialog } = useConfirm();
    const { classeNom } = useClasseContext();
  const navigate = useNavigate();
  // Groupes imposées 
  // Les Noms de groupes sélectionnable
  const [selectedItems, setSelectedItems] = useState(() => {
  if (conservationMode) {
    // Pré-remplir selectedItems avec les correspondances groupeId -> groupeId
    const initialItems = {};
    Object.keys(elevesParCluster).forEach(clusterId => {
      const groupe = listGroupes.find(g =>
        g.id === parseInt(clusterId) || g.nom === clusterId
      );
      if (groupe) {
        initialItems[groupe.id] = groupe.id;
      }
    });
    return initialItems;
  }
  return {};
});

  const tousLesIdsDesElevesDansClusters = useMemo(() => {
    return Object.values(elevesParCluster).flatMap(group => 
      group.map(eleve => eleve.id)
    );
  }, [elevesParCluster]); // elevesParCluster est la dépendance

  const elevesNonAffectes = useMemo(() => {
    // Assurer que 'eleves' est défini et contient une liste d'éléments avant de procéder
    return eleves?.eleves?.filter(eleve => !tousLesIdsDesElevesDansClusters.includes(eleve.id));
}, [eleves, tousLesIdsDesElevesDansClusters]); // Dépendances sur eleves et les IDs collectés
 
  // On post les groupes 
  const [{ isLoading: isLoadingPost }, doPost] = usePostApi(url + "groupes/affecter-eleves/");

 const selectedSavoirs = useMemo(() => {
  const result = [];
  
  // Vérifier que selectedEvalClasse existe et que elevesParCluster n'est pas vide
  if (selectedEvalClasse && elevesParCluster && Object.keys(elevesParCluster).length > 0) {
    // Trouver le premier cluster non vide
    const nonEmptyCluster = Object.keys(elevesParCluster).find(
      clusterId => elevesParCluster[clusterId] && elevesParCluster[clusterId].length > 0
    );
    
    // Si on trouve un cluster non vide
    if (nonEmptyCluster && elevesParCluster[nonEmptyCluster][0]) {
      Object.keys(elevesParCluster[nonEmptyCluster][0]).forEach(key => {
        if (!['id', 'nom', 'prenom', 'Cluster', 'score_obtenu', 'classe_nom'].includes(key)) {
          const [savoir, comp] = key.split('&');
          const existingSavoir = result.find(item => item.savoir === savoir);
          
          if (existingSavoir) {
            existingSavoir.comp.push(comp);
          } else {
            result.push({
              savoir: savoir,
              comp: [comp]
            });
          }
        }
      });
    } else {
      console.warn("Aucun cluster non vide trouvé dans elevesParCluster");
    }
  }
  
  return result;
}, [elevesParCluster, selectedEvalClasse]);


  const totalCompCount = useMemo(() => {
    return selectedSavoirs.reduce((acc, item) => acc + item.comp.length, 0)*6;
  }, [selectedSavoirs]);

  // Export .xlsx des groupes (mode intra-classe uniquement)
  const handleExportGroupes = useCallback(() => {
    if (!clusters || Object.keys(clusters).length === 0) return;

    const workbook = XLSX.utils.book_new();

    const headers = ['Élève'];
    selectedSavoirs.forEach(({ savoir, comp }) => {
      comp.forEach(c => headers.push(`${savoir}: ${c}`));
    });
    headers.push('Score Total');

    Object.entries(clusters).forEach(([clusterId, elevesCluster], index) => {
      const rows = elevesCluster.map(student => {
        const row = [`${student.nom.toUpperCase()} ${student.prenom}`];
        selectedSavoirs.forEach(({ savoir, comp }) => {
          comp.forEach(c => {
            row.push(student[`${savoir}&${c}`] ?? '');
          });
        });
        row.push(student.score_obtenu ?? 0);
        return row;
      });

      const sheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const sheetName = `Groupe ${index + 1} (${elevesCluster.length})`;
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    XLSX.writeFile(workbook, `Groupes_${classeNom}.xlsx`);
  }, [clusters, selectedSavoirs, classeNom]);


  // Le nombre d'items évalués au total.
  const totalQuestions = (selectedAutomatismes?.length + selectedProblemes?.length) || (selectedLexique?.length + selectedComprehension?.length) || selectedCompetences?.length;

  // Grouper dynamiquement les questions de compréhension par texte (Arachné, Sommeil, Petit Chose, Gaspillage, etc.)
  const comprehensionGroups = useMemo(() => {
    if (!selectedComprehension || selectedComprehension.length === 0) return [];

    const groups = {};
    selectedComprehension.forEach(q => {
      // Extraire le nom du texte (tout sauf le dernier " Qxx")
      const lastSpaceIdx = q.lastIndexOf(' ');
      if (lastSpaceIdx === -1) return;
      const texteName = q.substring(0, lastSpaceIdx);
      if (!groups[texteName]) groups[texteName] = [];
      groups[texteName].push(q);
    });

    // Normaliser le nom du texte en clé backend (ex: "Petit Chose" → "petit_chose")
    const normalizeToKey = (name) =>
      name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '_');

    const colorPalette = [
      { border: 'border-orange-200', text: 'text-orange-700', borderDetail: 'border-orange-100', textDetail: 'text-orange-800', iconColor: 'text-orange-600' },
      { border: 'border-amber-200', text: 'text-amber-700', borderDetail: 'border-amber-100', textDetail: 'text-amber-800', iconColor: 'text-amber-600' },
      { border: 'border-pink-200', text: 'text-pink-700', borderDetail: 'border-pink-100', textDetail: 'text-pink-800', iconColor: 'text-pink-600' },
      { border: 'border-violet-200', text: 'text-violet-700', borderDetail: 'border-violet-100', textDetail: 'text-violet-800', iconColor: 'text-violet-600' },
    ];

    return Object.entries(groups).map(([texteName, questions], idx) => ({
      texteName,
      questions,
      tache: `${normalizeToKey(texteName)}_filtrées`,
      shortLabel: `C${texteName.split(' ').map(w => w[0].toUpperCase()).join('')}`,
      colors: colorPalette[idx % colorPalette.length],
    }));
  }, [selectedComprehension]);

  // Vérifie si l'élève était absent (toutes réponses "Unknown" ou null pour eval nat)
  const isAbsent = (student) => {
    if (!student || selectedEvalClasse) return false;

    // Vérifier les clés .score réelles (reponses_xxx_filtrées.Q01.score)
    // Si l'élève a au moins un score numérique, il est présent (même score=0 = mauvaise réponse)
    const scoreKeys = Object.keys(student).filter(key => key.endsWith('.score'));
    if (scoreKeys.some(key => typeof student[key] === 'number')) return false;

    // Fallback : vérifier les clés "Response" (automatismes/problèmes)
    const responseKeys = Object.keys(student).filter(key => key.includes('Response'));
    if (responseKeys.length === 0) return false;

    return responseKeys.every(key => student[key] === "Unknown" || student[key] === null);
  };

  const getColor = (score, student = null) => {
    // Si élève absent en éval nationale -> grisé
    if (!selectedEvalClasse && student && isAbsent(student)) {
      return 'border-l-4 border-l-zinc-400 bg-gradient-to-r from-zinc-200 via-zinc-100 to-zinc-50'
    }

    let percentage = "";
    if(selectedEvalClasse){
      percentage = (score/totalCompCount) * 100;
    }
    else {
      percentage = (score / totalQuestions) * 100;
    }

    // Grisé pour eval classe si percentage === 0 ou NaN
    if(selectedEvalClasse && (percentage === 0 || isNaN(percentage))){
      return 'border-l-4 border-l-zinc-400 bg-gradient-to-r from-zinc-200 via-zinc-100 to-zinc-50'
    }
    else if (percentage <= 25) {
      return 'border-l-4 border-l-red-500 bg-gradient-to-r from-red-200 via-red-100 to-red-50'
    }
    else if(percentage <= 50){
      return 'border-l-4 border-l-orange-500 bg-gradient-to-r from-orange-200 via-orange-100 to-orange-50'
    }
    else if(percentage <= 75){
      return 'border-l-4 border-l-yellow-500 bg-gradient-to-r from-yellow-200 via-yellow-100 to-yellow-50'
    }
    else if(percentage > 75){
      return 'border-l-4 border-l-green-500 bg-gradient-to-r from-green-200 via-green-100 to-green-50'
    }
    else{
      return 'border-l-4 border-l-zinc-400 bg-gradient-to-r from-zinc-200 via-zinc-100 to-zinc-50'
    }
  };

  // Fonction de tri des élèves
  const sortStudents = (students) => {
    if (!students || sortMode === 'default') return students;

    const sorted = [...students];

    switch (sortMode) {
      case 'name':
        return sorted.sort((a, b) => {
          const nameA = `${a.nom} ${a.prenom}`.toLowerCase();
          const nameB = `${b.nom} ${b.prenom}`.toLowerCase();
          return nameA.localeCompare(nameB);
        });
      case 'score-desc':
        return sorted.sort((a, b) => (b.score_obtenu || 0) - (a.score_obtenu || 0));
      case 'score-asc':
        return sorted.sort((a, b) => (a.score_obtenu || 0) - (b.score_obtenu || 0));
      default:
        return students;
    }
  };

  // Le handle Change de la selection de noms de groupes.
const handleSelectionChange = (clusterID, selectedItem) => {
  const groupId = selectedItem === '' ? null : parseInt(selectedItem) || selectedItem;
  const clusterKey = String(clusterID);
  
  // Vérifier si ce groupe est déjà sélectionné ailleurs
  const isAlreadySelected = groupId && Object.entries(selectedItems).some(
    ([id, selectedId]) => {
      return String(id) !== clusterKey && String(selectedId) === String(groupId);
    }
  );
  
  if (isAlreadySelected) {
    alert("Ce groupe est déjà attribué à une autre classe !");
    return;
  }
  
  // NOUVEAU : Réorganiser les clusters si on sélectionne un groupe
  if (selectedItem && !conservationMode) {
    const newClusters = { ...clusters };
    const currentClusterData = newClusters[clusterID];
    
    // Si on assigne un groupe, changer la clé du cluster pour correspondre au groupId
    if (currentClusterData) {
        // ✅ AJOUT : Vérifier si la clé cible existe déjà
      if (newClusters[groupId] && groupId !== clusterID) {
        // Générer une clé unique au lieu d'écraser
        let uniqueKey = `${groupId}_cluster`;
        let counter = 1;
        while (newClusters[uniqueKey]) {
          uniqueKey = `${groupId}_cluster_${counter}`;
          counter++;
        } 
        delete newClusters[clusterID];
        newClusters[uniqueKey] = currentClusterData;
        setClusters(newClusters);
        setModifsManuelles(true);
        
        setSelectedItems(prev => {
          const newItems = { ...prev };
          delete newItems[clusterID];
          newItems[uniqueKey] = groupId;  // Stocker le vrai groupId
          return newItems;
        });
      } else {
        // Pas de conflit, procéder normalement
        delete newClusters[clusterID];
        newClusters[groupId] = currentClusterData;
        
        setClusters(newClusters);
        setModifsManuelles(true);
        
        setSelectedItems(prev => {
          const newItems = { ...prev };
          delete newItems[clusterID];
          newItems[groupId] = groupId;
          return newItems;
        });
      }
    }
  } else if (!selectedItem && !conservationMode) {
    // Si on désélectionne, remettre l'index original
    const currentGroupId = selectedItems[clusterID];
    if (currentGroupId) {
      const newClusters = { ...clusters };
      const currentClusterData = newClusters[currentGroupId];
      
      if (currentClusterData) {
        // Trouver le prochain index disponible (position d'origine ou nouvelle)
        const originalIndex = Object.keys(elevesParCluster).indexOf(clusterID.toString());
        let newKey = originalIndex >= 0 ? originalIndex.toString() : clusterID;
        
        // S'assurer que la clé n'existe pas déjà
        while (newClusters[newKey]) {
          newKey = Math.max(...Object.keys(newClusters).map(Number)) + 1;
          newKey = newKey.toString();
        }
        
        // Réorganiser
        delete newClusters[currentGroupId];
        newClusters[newKey] = currentClusterData;
        
        setClusters(newClusters);
        setModifsManuelles(true);
        
        // Mettre à jour selectedItems
        setSelectedItems(prev => {
          const { [clusterID]: _, ...newState } = prev;
          return newState;
        });
      }
    }
  } else if (conservationMode) {
    // Mode conservation : logique originale
    setSelectedItems(prev => {
      if (selectedItem) {
        return { ...prev, [clusterID]: selectedItem };
      } else {
        const { [clusterID]: _, ...newState } = prev;
        return newState;
      }
    });
  }
};
  // On mets à jour les items sélectionnable.
  const onDragStart = () => {
    setIsDragging(true);
  };
  const onDragEnd = (result) => {
   
    setIsDragging(false);

    if (!result.destination){
     
      return;
    }

    const { source, destination } = result;
   

    // Extraire l'ID de l'élève depuis le draggableId
    const studentId = parseInt(result.draggableId);
 
    // Deep clone de clusters pour éviter les mutations
    const newClusters = Object.keys(clusters).reduce((acc, key) => {
      acc[key] = [...clusters[key]]; // Copier chaque tableau d'élèves
      return acc;
    }, {});

    // S'assurer que source.droppableId et destination.droppableId sont corrects
    const sourceCluster = newClusters[source.droppableId];
    const destinationCluster = newClusters[destination.droppableId];

    if (!sourceCluster || !destinationCluster) {
  
      return;
    }

   
    // Trouver l'élève par son ID (pas par index, car le tri peut changer l'ordre visuel)
    const studentIndex = sourceCluster.findIndex(s => s.id === studentId);
    if (studentIndex === -1) {
      console.error("❌ Student not found in source cluster by ID:", studentId);
      return;
    }

    // Effectuer le déplacement
    const [removed] = sourceCluster.splice(studentIndex, 1);
  
    // Si pas de tri actif, insérer à la position où on drop
    // Si tri actif, ajouter à la fin (l'ordre sera géré par le tri à l'affichage)
    if (sortMode === 'default') {
      destinationCluster.splice(destination.index, 0, removed);
    } else {
      destinationCluster.push(removed);
    }

   
    // Vérifier les doublons AVANT nettoyage
    const destIds = destinationCluster.map(e => e.id);
    const duplicates = destIds.filter((id, index) => destIds.indexOf(id) !== index);
    if (duplicates.length > 0) {
      console.error("🚨 DUPLICATES FOUND in destination cluster (before cleaning):", duplicates);
    }

    // NETTOYER LES DOUBLONS GLOBALEMENT après le drag & drop
    const cleanedClusters = cleanDuplicatesInClusters(newClusters);

    setClusters(cleanedClusters);
    setModifsManuelles(true);
  
  };

  const calculerPourcentageReussite = (eleves, question, tache) => {

    const totalReponses = eleves.length;
    let reponsesCorrectes = 0;
    eleves.forEach(eleve => {
      // Ici, nous essayons de dynamiquement accéder à la propriété de l'objet basé sur la question passée en argument
      const score = eleve[`reponses_${tache}.${question}.score`];
      if(score === 1) {
        reponsesCorrectes += 1;
      }
    });
    return totalReponses > 0 ? (reponsesCorrectes / totalReponses * 100).toFixed(2) : 0;
  };

  const calculerPourcentageReussiteEvalClasse = (eleves, savoir, comp) => {
 
    let totalReponses = 0;
    let reponsesCorrectes = 0;
    eleves.forEach(eleve => {
      // Ici, nous essayons de dynamiquement accéder à la propriété de l'objet basé sur la question passée en argument
      const score = eleve[`${savoir}&${comp}`];
      // Si le score est différent de 0, on l'inclut dans le total
    if (score !== null) {
      totalReponses += 1;

      // Si le score est supérieur ou égal à 3, on compte la réponse comme correcte
      if (score >= 3) {
        reponsesCorrectes += 1;
      }
    }
  });
    return totalReponses > 0 ? (reponsesCorrectes / totalReponses * 100).toFixed(2) : 0;

  };

  const handleOnChange = () => {
    setShowDetails(!showDetails); // Change l'état à chaque clic
  };

 


 const handleSubmit = async() => {
  const affectations = {
    affectations: Object.keys(selectedItems).map((key) => {
      // La clé peut être "1_cluster" mais selectedItems[key] contient le vrai groupId
      const groupId = selectedItems[key];
      const elevesIds = clusters[key]?.map((e) => e.id);

      if (!elevesIds || elevesIds.length === 0) {
        console.warn(`Pas d'élèves trouvés pour la clé ${key}`);
        return null;
      }

      return { groupId, elevesIds };
    }).filter(Boolean) // Enlever les null
  };

  const nbGroupes = affectations.affectations.length;
  const nbEleves = affectations.affectations.reduce((n, a) => n + a.elevesIds.length, 0);

  // Confirmation AVANT l'envoi : la transmission affecte réellement les élèves
  const ok = await confirm({
    title: 'Transmettre les groupes ?',
    message: `${nbEleves} élève${nbEleves > 1 ? 's' : ''} vont être affectés à ${nbGroupes} groupe${nbGroupes > 1 ? 's' : ''} selon la répartition affichée.`,
    confirmLabel: 'Transmettre',
    variant: 'warning',
  });
  if (!ok) return;

  // Verdict lu sur le RETOUR de doPost : l'ancien test isErrorPost/isLoadingPost
  // lisait des états figés au render (closure) et naviguait dans TOUS les cas,
  // échec compris, sans aucun message.
  const resultat = await doPost(affectations);
  if (resultat?.success) {
    alert('Groupes transmis avec succès !');
    selectedBarette ? navigate(`/home/admin-groupe/`) : navigate('/home/');
  } else {
    alert("La transmission a échoué : les affectations n'ont pas été enregistrées. Vérifiez votre connexion puis réessayez.");
  }
 }
 // Fonction pour déterminer la couleur selon le pourcentage
  const getColorClass = (percentage) => {
    if (percentage < 40) return 'text-red-600 bg-red-50 border-red-200';
    if (percentage < 70) return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    return 'text-green-600 bg-green-50 border-green-200';
  };

  // Fonction pour obtenir l'icône de tendance
  const getTrendIcon = (percentage) => {
    if (percentage >= 80) return <TrendingUp className="w-3 h-3" />;
    if (percentage >= 40) return <Activity className="w-3 h-3" />;
    return <TrendingDown className="w-3 h-3" />;
  };
 
  const handleToggleSelect = (studentId) => {
  setSelectedStudents(prev => {
    const newSet = new Set(prev);
    if (newSet.has(studentId)) {
      newSet.delete(studentId);
    } else {
      newSet.add(studentId);
    }
    return newSet;
  });
};

// Dans le cas des evaluations bilan, si on a des élèves qui n'ont pas participer,
//  on les affiche quand même dans la répartition de groupe sur le dernier cluster.
useEffect(() => {
  if (elevesNonAffectes && elevesNonAffectes.length > 0) {
    setClusters(prev => {
      // Collecter tous les IDs déjà présents dans les clusters pour éviter les doublons
      const existingIds = new Set();
      Object.values(prev).forEach(clusterEleves => {
        clusterEleves.forEach(eleve => existingIds.add(eleve.id));
      });

      // Filtrer pour ne garder que les élèves NON déjà présents
      const nouveauxEleves = elevesNonAffectes.filter(eleve => !existingIds.has(eleve.id));

      // Si aucun nouvel élève à ajouter, ne pas modifier l'état (évite re-render infini)
      if (nouveauxEleves.length === 0) {
        return prev;
      }

      const newClusters = { ...prev };
      const lastKey = Object.keys(newClusters).pop();

      if (lastKey) {
        newClusters[lastKey] = [...newClusters[lastKey], ...nouveauxEleves];
      }

      return newClusters;
    });
  }
}, [elevesNonAffectes])

const moveSelectedStudents = (targetGroupId) => {
  const newClusters = { ...clusters };
  const studentsToMove = [];
  
  // Collecter tous les élèves sélectionnés et les retirer de leurs groupes actuels
  Object.keys(newClusters).forEach(clusterId => {
    const studentsToKeep = [];
    newClusters[clusterId].forEach(eleve => {
      if (selectedStudents.has(eleve.id)) {
        studentsToMove.push(eleve);
      } else {
        studentsToKeep.push(eleve);
      }
    });
    newClusters[clusterId] = studentsToKeep;
  });
  
  // Ajouter les élèves au groupe cible
  if (newClusters[targetGroupId]) {
    newClusters[targetGroupId] = [...newClusters[targetGroupId], ...studentsToMove];
  }
  
  // Mettre à jour l'état
  setClusters(newClusters);
  setModifsManuelles(true);
  setSelectedStudents(new Set());
  setSelectionMode(false);
  
  // Notification de succès (optionnel)
  alert(`${studentsToMove.length} élève(s) déplacé(s) vers ${listGroupes.find(g => g.id === parseInt(targetGroupId))?.nom || 'le groupe'}`);
};

// Student Card Component
  const StudentCard = ({ student, groupId, showDetails , isSelected, onToggleSelect, selectionMode}) => {


    return (

         <div
     className={`mb-1 rounded-md hover:shadow-sm transition-all duration-150 relative
      ${getColor(student.score_obtenu, student)}
      ${isDragging ? 'opacity-50' : ''}
      ${isSelected ? 'ring-1 ring-blue-400 bg-blue-50/50' : ''}`}
    >
       {selectionMode && (
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggleSelect(student.id)}
          className="absolute left-1 top-1/2 -translate-y-1/2 w-3.5 h-3.5 cursor-pointer z-10"
          onClick={(e) => e.stopPropagation()}
        />
      )}

        <div className={`flex items-center gap-1.5 py-1 px-1 ${selectionMode ? 'pl-5' : ''}`}>
          <GripVertical size={14} className="text-gray-700 hover:text-blue-500 cursor-grab active:cursor-grabbing flex-shrink-0 transition-colors" />

          {/* Avatar compact */}
          <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-400 to-sky-500
            flex items-center justify-center text-white font-medium text-[10px] flex-shrink-0">
            {student.nom[0]}{student.prenom[0]}
          </div>

          <div className="flex-1 min-w-0 flex items-center gap-2">
            <span className="font-medium text-gray-700 text-xs truncate">
              {student.nom} {student.prenom}
            </span>
            {/* Classe discrète */}
            <span className="hidden sm:inline-block px-1.5 rounded-3xl bg-sky-50 text-sky-600 text-[10px] font-medium  border border-sky-200">
              {student.classe_nom}
            </span>
          </div>
        </div>
        
        {showDetails && (
          <div className="mt-1 pt-1 border-t border-gray-100">
            {/* Eval Classe - Savoirs */}
            {selectedEvalClasse && (
              <div className="overflow-x-auto py-1">
                <div className="flex gap-0.5 flex-wrap">
                  {selectedSavoirs.map((question, qIdx) => (
                    question.comp.map((comp, cIdx) => {
                      const scoreKey = `${question.savoir}&${comp}`;
                      const score = student[scoreKey];
                      const hasData = score !== undefined && score !== null;

                      // Couleur selon le score (0-6)
                      const getScoreStyle = (s) => {
                        if (s === undefined || s === null) return 'bg-gray-50 text-gray-400 border-gray-200';
                        if (s >= 5) return 'bg-emerald-50 text-emerald-700 border-emerald-300';
                        if (s >= 3) return 'bg-yellow-50 text-yellow-700 border-yellow-300';
                        return 'bg-red-50 text-red-600 border-red-300';
                      };

                      return (
                        <div key={`${qIdx}-${cIdx}`}
                          className={`px-1 py-0.5 rounded text-[8px] font-medium border ${getScoreStyle(score)}`}
                          title={`${question.savoir} - ${comp}: ${score ?? 0}/6`}
                        >
                          <span className="opacity-60">S{qIdx+1}C{cIdx+1}:</span> {hasData ? score : '—'}
                        </div>
                      );
                    })
                  ))}
                </div>
              </div>
            )}

            {/* Eval Nationale */}
            {!selectedEvalClasse && (
              <div className="overflow-x-auto py-1">
                <div className="flex gap-0.5 flex-wrap">
                  {/* Automatismes */}
                  {selectedAutomatismes.map((question, index) => {
                    const responseKey = `reponses_automatismes_filtrées.${question}.réponse`;
                    const scoreKey = `reponses_automatismes_filtrées.${question}.score`;
                    const score = student[scoreKey];
                    const réponse = student[responseKey];
                    const hasData = score !== undefined && réponse != null;
                    return (
                      <div key={`a-${index}`}
                        className={`px-1 py-0.5 rounded text-[8px] font-medium border
                          ${hasData
                            ? score === 1
                              ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                              : 'bg-red-50 text-red-600 border-red-300'
                            : 'bg-gray-50 text-gray-400 border-gray-200'}`}
                        title={`A${index+1}: ${question} → ${réponse || 'Rien'}`}
                      >
                        <span className="opacity-60">A{index+1}:</span> {hasData ? réponse : '—'}
                      </div>
                    );
                  })}

                  {/* Problèmes */}
                  {selectedProblemes.map((question, index) => {
                    const responseKey = `reponses_problèmes_filtrées.${question}.réponse`;
                    const scoreKey = `reponses_problèmes_filtrées.${question}.score`;
                    const score = student[scoreKey];
                    const réponse = student[responseKey];
                    const hasData = score !== undefined && réponse != null;
                    return (
                      <div key={`p-${index}`}
                        className={`px-1 py-0.5 rounded text-[8px] font-medium border
                          ${hasData
                            ? score === 1
                              ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                              : 'bg-red-50 text-red-600 border-red-300'
                            : 'bg-gray-50 text-gray-400 border-gray-200'}`}
                        title={`P${index+1}: ${question} → ${réponse || 'Rien'}`}
                      >
                        <span className="opacity-60">P{index+1}:</span> {hasData ? réponse : '—'}
                      </div>
                    );
                  })}

                  {/* Lexique */}
                  {selectedLexique.map((question, index) => {
                    const responseKey = `reponses_lexique_filtrées.${question}.réponse`;
                    const scoreKey = `reponses_lexique_filtrées.${question}.score`;
                    const score = student[scoreKey];
                    const réponse = student[responseKey];
                    const hasData = score !== undefined && réponse != null;
                    return (
                      <div key={`l-${index}`}
                        className={`px-1 py-0.5 rounded text-[8px] font-medium border
                          ${hasData
                            ? score === 1
                              ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                              : 'bg-red-50 text-red-600 border-red-300'
                            : 'bg-gray-50 text-gray-400 border-gray-200'}`}
                        title={`L${index+1}: ${question} → ${réponse || 'Rien'}`}
                      >
                        <span className="opacity-60">L{index+1}:</span> {hasData ? réponse : '—'}
                      </div>
                    );
                  })}

                  {/* Compétences */}
                  {selectedCompetences.map((question, index) => {
                    const responseKey = `reponses_competences_filtrées.${question}.réponse`;
                    const scoreKey = `reponses_competences_filtrées.${question}.score`;
                    const score = student[scoreKey];
                    const réponse = student[responseKey];
                    const hasData = score !== undefined && réponse != null;
                    return (
                      <div key={`c-${index}`}
                        className={`px-1 py-0.5 rounded text-[8px] font-medium border
                          ${hasData
                            ? score === 1
                              ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                              : 'bg-red-50 text-red-600 border-red-300'
                            : 'bg-gray-50 text-gray-400 border-gray-200'}`}
                        title={`C${index+1}: ${question} → ${réponse || 'Rien'}`}
                      >
                        <span className="opacity-60">C{index+1}:</span> {hasData ? réponse : '—'}
                      </div>
                    );
                  })}

                  {/* Compréhension écrite - dynamique par texte */}
                  {comprehensionGroups.map((group) =>
                    group.questions.map((question, index) => {
                      const responseKey = `reponses_${group.tache}.${question}.réponse`;
                      const scoreKey = `reponses_${group.tache}.${question}.score`;
                      const score = student[scoreKey];
                      const réponse = student[responseKey];
                      const hasData = score !== undefined && réponse != null;
                      return (
                        <div key={`${group.shortLabel}-${index}`}
                          className={`px-1 py-0.5 rounded text-[8px] font-medium border
                            ${hasData
                              ? score === 1
                                ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                                : 'bg-red-50 text-red-600 border-red-300'
                              : 'bg-gray-50 text-gray-400 border-gray-200'}`}
                          title={`${group.shortLabel}${index+1}: ${question} → ${réponse || 'Rien'}`}
                        >
                          <span className="opacity-60">{group.shortLabel}{index+1}:</span> {hasData ? réponse : '—'}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

// Composant pour la barre d'actions - Sans transform pour ne pas interférer avec drag&drop
const SelectionToolbar = ({ selectedCount, onMoveSelected, groups, onCancel }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="fixed bottom-6 left-0 right-0 flex justify-center" style={{ zIndex: 200 }}>
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200
                    px-6 xl:px-4 2xl:px-5 3xl:px-6 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
      <div className="flex items-center gap-2">
        <div className="bg-blue-100 text-blue-700 px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-1 rounded-full font-semibold text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
          {selectedCount} sélectionné(s)
        </div>
      </div>
      
      <div className="relative">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center text-sm xl:text-xs 2xl:text-xs 3xl:text-sm gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 bg-gradient-to-r from-blue-500 to-blue-600
                     text-white rounded-lg hover:shadow-lg transition-all"
        >
          <ArrowRightLeft size={16} className="xl:w-3.5 xl:h-3.5 2xl:w-[15px] 2xl:h-[15px] 3xl:w-4 3xl:h-4" />
          Déplacer vers
        </button>
        
        {showDropdown && (
          <div className="absolute bottom-full mb-2 left-0 bg-white rounded-lg shadow-xl
                          border border-gray-200 min-w-[200px] overflow-hidden" style={{ zIndex: 200 }}>
            {groups.map(group => (
              <button
                key={group.id}
                onClick={() => onMoveSelected(group.id)}
                className="w-full px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 text-left text-sm xl:text-xs 2xl:text-xs 3xl:text-sm hover:bg-blue-50 transition-colors
                           flex items-center justify-between"
              >
                <span>{group.nom}</span>
                <ChevronRight size={14} />
              </button>
            ))}
          </div>
        )}
      </div>
      
        <button
          onClick={onCancel}
          className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-semibold rounded-lg hover:from-orange-600 hover:to-orange-700 transition-colors shadow-lg shadow-orange-500/30"
        >
          Annuler
        </button>
      </div>
    </div>
  );
};


    return(

  <div className="min-h-screen w-full bg-gradient-to-br from-sky-50 via-blue-100 to-cyan-100 text-gray-800 overflow-x-hidden relative">
    {/* Background avec blobs animés - ABSOLUTE au lieu de FIXED pour ne pas interférer avec drag&drop */}
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="visuel-blob1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a5f3fc" stopOpacity="0.5" />
            <stop offset="50%" stopColor="#67e8f9" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#22d3ee" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="visuel-blob2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#bae6fd" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#7dd3fc" stopOpacity="0.25" />
          </linearGradient>
          <linearGradient id="visuel-blob3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#e0f2fe" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#bae6fd" stopOpacity="0.2" />
          </linearGradient>
        </defs>

        {/* Blob 1 */}
        <path fill="url(#visuel-blob1)">
          <animate
            attributeName="d"
            dur="8s"
            repeatCount="indefinite"
            values="
              M5,20 Q15,5 30,15 Q45,25 40,40 Q35,55 20,50 Q5,45 5,20;
              M10,15 Q25,0 35,12 Q45,24 42,42 Q39,60 22,52 Q5,44 10,15;
              M8,22 Q18,8 32,18 Q46,28 42,45 Q38,62 23,52 Q8,42 8,22;
              M5,20 Q15,5 30,15 Q45,25 40,40 Q35,55 20,50 Q5,45 5,20
            "
          />
        </path>

        {/* Blob 2 */}
        <path fill="url(#visuel-blob2)">
          <animate
            attributeName="d"
            dur="10s"
            repeatCount="indefinite"
            values="
              M70,10 Q90,15 92,35 Q94,55 80,50 Q66,45 68,25 Q70,5 70,10;
              M75,8 Q95,12 95,32 Q95,52 82,48 Q69,44 70,24 Q71,4 75,8;
              M68,12 Q88,18 90,38 Q92,58 78,52 Q64,46 66,26 Q68,6 68,12;
              M70,10 Q90,15 92,35 Q94,55 80,50 Q66,45 68,25 Q70,5 70,10
            "
          />
        </path>

        {/* Blob 3 */}
        <path fill="url(#visuel-blob3)">
          <animate
            attributeName="d"
            dur="7s"
            repeatCount="indefinite"
            values="
              M35,60 Q50,55 60,68 Q70,81 55,88 Q40,95 32,82 Q24,69 35,60;
              M38,58 Q55,52 65,65 Q75,78 58,86 Q41,94 34,80 Q27,66 38,58;
              M33,62 Q48,58 58,70 Q68,82 52,90 Q36,98 30,84 Q24,70 33,62;
              M35,60 Q50,55 60,68 Q70,81 55,88 Q40,95 32,82 Q24,69 35,60
            "
          />
        </path>

        {/* Particules flottantes */}
        <circle cx="15" cy="40" r="1.5" fill="#67e8f9" opacity="0.6">
          <animate attributeName="cy" dur="4s" values="40;35;40" repeatCount="indefinite" />
        </circle>
        <circle cx="55" cy="25" r="1" fill="#7dd3fc" opacity="0.5">
          <animate attributeName="cy" dur="5s" values="25;20;25" repeatCount="indefinite" />
        </circle>
        <circle cx="75" cy="45" r="1.2" fill="#a5f3fc" opacity="0.5">
          <animate attributeName="cy" dur="3.5s" values="45;40;45" repeatCount="indefinite" />
        </circle>
      </svg>

      {/* Cercles flous */}
      <div className="absolute top-20 left-1/4 w-72 h-72 bg-cyan-100/40 rounded-full blur-3xl" />
      <div className="absolute bottom-40 right-1/4 w-64 h-64 bg-sky-100/50 rounded-full blur-3xl" />
    </div>

    {/* Header */}
    <header className="relative z-20 pt-4 sm:pt-6 pb-4 sm:pb-6 px-3 sm:px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Bouton retour */}
        <button
          className="mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4 px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-medium
            hover:from-orange-600 hover:to-orange-700 transition-colors duration-200
            shadow-lg shadow-orange-500/30 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2"
          onClick={async () => {
            // Le retour au formulaire perd tout le travail de répartition :
            // confirmation si des modifications manuelles ont eu lieu.
            if (modifsManuelles) {
              const ok = await confirm({
                title: 'Revenir au formulaire ?',
                message: 'Vos déplacements d\'élèves et attributions de groupes seront perdus.',
                confirmLabel: 'Revenir quand même',
                variant: 'warning',
              });
              if (!ok) return;
            }
            setIsSubmit(false);
          }}
        >
          ← RETOUR
        </button>

        {/* Top bar avec titre et actions */}
        <div className="bg-white/90 rounded-2xl border border-sky-200 shadow-lg p-4 sm:p-6 xl:p-4 2xl:p-5 3xl:p-6 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            {/* Titre */}
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 xl:w-9 xl:h-9 2xl:w-10 2xl:h-10 3xl:w-12 3xl:h-12 bg-gradient-to-br from-blue-500 to-sky-500 rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
                <Users className="w-5 h-5 sm:w-7 sm:h-7 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 3xl:w-7 3xl:h-7 text-white" />
              </div>
              <div className="min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-bold text-gray-800 flex items-center gap-2 flex-wrap">
                  <span>Répartition des Groupes</span>
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-amber-500 animate-pulse flex-shrink-0" />
                </h1>
                <p className="text-gray-600 text-xs sm:text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">Glissez-déposez les élèves entre les groupes</p>
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3 flex-wrap">
              {/* Bouton Sélection multiple */}
              <button
                onClick={() => {
                  if (Object.keys(selectedItems).length !== Object.keys(clusters).length) {
                    alert("Veuillez d'abord attribuer les groupes avant d'utiliser le mode sélection multiple");
                    return;
                  }
                  setSelectionMode(!selectionMode);
                  setSelectedStudents(new Set());
                }}
                disabled={Object.keys(selectedItems).length !== Object.keys(clusters).length}
                className={`px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2.5 xl:py-2 2xl:py-2 3xl:py-2.5 rounded-xl font-medium flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 transition-colors duration-300 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm
                  ${Object.keys(selectedItems).length === 0
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed opacity-50'
                    : selectionMode
                      ? 'bg-gradient-to-r from-blue-500 to-sky-500 text-white shadow-lg shadow-blue-500/30'
                      : 'bg-white border border-sky-200 text-gray-700 hover:bg-sky-50 hover:border-sky-300 shadow-md'}`}
                title={Object.keys(selectedItems).length !== Object.keys(clusters).length
                  ? "Attribuez d'abord les groupes pour activer cette fonctionnalité"
                  : "Activer le mode sélection multiple"}
              >
                <CheckSquare size={18} className="xl:w-4 xl:h-4 2xl:w-[17px] 2xl:h-[17px] 3xl:w-[18px] 3xl:h-[18px]" />
                {selectionMode ? 'Mode sélection actif' : 'Sélection multiple'}
              </button>

              {/* Toggle Détails par élève */}
              <button
                onClick={handleOnChange}
                className={`px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2.5 xl:py-2 2xl:py-2 3xl:py-2.5 rounded-xl font-medium flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 transition-colors duration-300 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm
                  ${showDetails
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-lg shadow-emerald-500/30'
                    : 'bg-white border border-sky-200 text-gray-700 hover:bg-sky-50 hover:border-sky-300 shadow-md'}`}
              >
                {showDetails ? <Eye size={18} className="xl:w-4 xl:h-4 2xl:w-[17px] 2xl:h-[17px] 3xl:w-[18px] 3xl:h-[18px]" /> : <EyeOff size={18} className="xl:w-4 xl:h-4 2xl:w-[17px] 2xl:h-[17px] 3xl:w-[18px] 3xl:h-[18px]" />}
                Détails par élève
              </button>

              {/* Boutons de tri */}
              <div className="flex items-center gap-1 bg-white border border-sky-200 rounded-xl p-1 shadow-md">
                <button
                  onClick={() => setSortMode('name')}
                  className={`px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 rounded-lg font-medium flex items-center gap-1.5 transition-colors duration-200 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm
                    ${sortMode === 'name'
                      ? 'bg-gradient-to-r from-blue-500 to-sky-500 text-white'
                      : 'text-gray-600 hover:bg-sky-50'}`}
                  title="Trier par nom"
                >
                  <ArrowUpAZ size={16} className="xl:w-3.5 xl:h-3.5 2xl:w-[15px] 2xl:h-[15px] 3xl:w-4 3xl:h-4" />
                  <span className="hidden sm:inline">Nom</span>
                </button>
                <button
                  onClick={() => setSortMode(sortMode === 'score-desc' ? 'score-asc' : 'score-desc')}
                  className={`px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 rounded-lg font-medium flex items-center gap-1.5 transition-colors duration-200 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm
                    ${sortMode === 'score-desc' || sortMode === 'score-asc'
                      ? 'bg-gradient-to-r from-blue-500 to-sky-500 text-white'
                      : 'text-gray-600 hover:bg-sky-50'}`}
                  title="Trier par score"
                >
                  <ArrowDownWideNarrow size={16} className="xl:w-3.5 xl:h-3.5 2xl:w-[15px] 2xl:h-[15px] 3xl:w-4 3xl:h-4" />
                  <span className="hidden sm:inline">Score {sortMode === 'score-asc' ? '↑' : '↓'}</span>
                </button>
                {sortMode !== 'default' && (
                  <button
                    onClick={() => setSortMode('default')}
                    className="px-2 py-2 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
                    title="Réinitialiser le tri"
                  >
                    ✕
                  </button>
                )}
              </div>

              {/* Bouton Export .xlsx (mode intra-classe uniquement) */}
              {classeNom  && (
                <button
                  onClick={handleExportGroupes}
                  className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2.5 xl:py-2 2xl:py-2 3xl:py-2.5
                    bg-white border border-emerald-200 text-emerald-600 rounded-xl font-medium
                    flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2
                    hover:bg-emerald-50 hover:border-emerald-300 hover:shadow-md
                    transition-all duration-200 shadow-md text-sm xl:text-xs 2xl:text-xs 3xl:text-sm"
                >
                  <Download size={18} className="xl:w-4 xl:h-4 2xl:w-[17px] 2xl:h-[17px] 3xl:w-[18px] 3xl:h-[18px]" />
                  Export .xlsx
                </button>
              )}
            </div>
          </div>

          {/* Info Alert */}
          <div className="mt-4 xl:mt-3 2xl:mt-3.5 3xl:mt-4 flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 bg-amber-50 border border-amber-200 rounded-xl p-3 xl:p-2 2xl:p-2.5 3xl:p-3">
            <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-gradient-to-br from-amber-400 to-orange-400 text-white rounded-lg flex items-center justify-center flex-shrink-0 shadow-md text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
              !
            </div>
            <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-amber-800">
              <strong>Astuce :</strong> Activez les détails par élève pour voir les scores individuels.
            </p>
          </div>

          {/* Légende des codes */}
          <div className="mt-3 xl:mt-2 2xl:mt-2.5 3xl:mt-3 bg-sky-50 border border-sky-200 rounded-xl p-4 xl:p-3 2xl:p-3.5 3xl:p-4">
            <div className="flex items-start gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
              <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-gradient-to-br from-blue-500 to-sky-500 text-white rounded-lg flex items-center justify-center flex-shrink-0 shadow-md text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs font-bold">
                ?
              </div>
              <div className="flex-1">
                <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-semibold text-sky-800 mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">Légende des codes :</p>
                {selectedEvalClasse ? (
                  <div className="flex flex-wrap gap-2 text-xs">
                    <span className="bg-white px-2 py-1 rounded-md border border-sky-200 text-sky-700">
                      <strong>S</strong> = Savoir
                    </span>
                    <span className="bg-white px-2 py-1 rounded-md border border-sky-200 text-sky-700">
                      <strong>C</strong> = Compétence
                    </span>
                    <span className="bg-white px-2 py-1 rounded-md border border-sky-200 text-gray-600">
                      Ex: <strong>S1C2</strong> = Savoir 1, Compétence 2
                    </span>
                    <span className="bg-emerald-50 px-2 py-1 rounded-md border border-emerald-200 text-emerald-700">
                      Score ≥5 = Acquis
                    </span>
                    <span className="bg-yellow-50 px-2 py-1 rounded-md border border-yellow-200 text-yellow-700">
                      Score 3-4 = En cours
                    </span>
                    <span className="bg-red-50 px-2 py-1 rounded-md border border-red-200 text-red-600">
                      Score &lt;3 = Non acquis
                    </span>
                  </div>
                ) : (
                  <div className="flex flex-wrap gap-2 text-xs">
                    <span className="bg-white px-2 py-1 rounded-md border border-teal-200 text-teal-700">
                      <strong>A</strong> = Automatismes
                    </span>
                    <span className="bg-white px-2 py-1 rounded-md border border-red-200 text-red-700">
                      <strong>P</strong> = Problèmes
                    </span>
                    <span className="bg-white px-2 py-1 rounded-md border border-purple-200 text-purple-700">
                      <strong>L</strong> = Lexique
                    </span>
                    <span className="bg-white px-2 py-1 rounded-md border border-indigo-200 text-indigo-700">
                      <strong>C</strong> = Compétences
                    </span>
                    {comprehensionGroups.map((group) => (
                      <span key={group.shortLabel} className={`bg-white px-2 py-1 rounded-md border ${group.colors.border} ${group.colors.text}`}>
                        <strong>{group.shortLabel}</strong> = Compréhension {group.texteName}
                      </span>
                    ))}
                    <span className="bg-emerald-50 px-2 py-1 rounded-md border border-emerald-200 text-emerald-700">
                      Vert = Correct
                    </span>
                    <span className="bg-red-50 px-2 py-1 rounded-md border border-red-200 text-red-600">
                      Rouge = Incorrect
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    {/* Contenu principal */}
    <main className="relative z-20 px-3 sm:px-4 md:px-8 pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid 4xl:grid-cols-4 3xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-5">
          <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
            {Object.entries(clusters).map(([clusterId, eleves]) => (
              <div key={clusterId}
                className="bg-white rounded-2xl p-5 xl:p-3.5 2xl:p-4 3xl:p-5 shadow-lg border border-sky-100 custom-scrollbar"
                style={{
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#e0e0e0 transparent'
                }}
              >
                <div className="flex justify-between items-center mb-3 xl:mb-2 2xl:mb-2.5 3xl:mb-3 pb-3 xl:pb-2 2xl:pb-2.5 3xl:pb-3 border-b-2 border-sky-100">
                  <div className="flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 text-gray-800 font-semibold">
                    <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-gradient-to-br from-blue-500 to-sky-500 rounded-lg flex items-center justify-center">
                      <Users className="w-4 h-4 xl:w-3 xl:h-3 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4 text-white" />
                    </div>
                    <span className="text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base">Groupe d'affectation</span>
                  </div>
                  <span className="bg-gradient-to-r from-blue-500 to-sky-500 text-white px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-1 rounded-full text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs font-bold shadow-md">
                    {eleves.length} élèves
                  </span>
                </div>

                {conservationMode && (
                  <div className="flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 mt-2 xl:mt-1.5 2xl:mt-1.5 3xl:mt-2 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-600">
                    <Lock size={14} className="xl:w-3 xl:h-3 2xl:w-3.5 2xl:h-3.5 3xl:w-3.5 3xl:h-3.5" />
                    <span>Groupe conservé automatiquement</span>
                  </div>
                )}

                {!classeNom && (
                  <select
                    value={(selectedItems[clusterId] || '')}
                    onChange={(e) => handleSelectionChange(clusterId, e.target.value)}
                    disabled={conservationMode}
                    className={`w-full mt-3 xl:mt-2 2xl:mt-2.5 3xl:mt-3 xl:text-xs 2xl:text-sm 3xl:text-sm text-sm px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-2.5 xl:py-2 2xl:py-2 3xl:py-2.5 border-2 rounded-xl bg-white/90 text-gray-700
                      transition-all duration-200 cursor-pointer
                      ${conservationMode
                        ? 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-75'
                        : 'border-sky-200 hover:border-sky-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200'
                      }`}
                  >
                    <option value="">Sélectionner un groupe</option>
                    {listGroupes.map(groupe => (
                      <option
                        key={groupe.id}
                        value={groupe.id}
                        disabled={Object.values(selectedItems).includes(groupe.id) && selectedItems[clusterId] !== groupe.id}
                      >
                        {groupe.nom}
                        {Object.values(selectedItems).includes(groupe.id) && selectedItems[clusterId] !== groupe.id && ' (Déjà attribué)'}
                      </option>
                    ))}
                  </select>
                )}
  {/* Header Stats Compact avec Hover */}
  <div className="relative group/stats mb-4">
    {/* Badges compacts */}
    <div className="flex flex-wrap gap-2 p-3 bg-gradient-to-r from-slate-50 to-blue-50 rounded-xl border border-slate-200 cursor-pointer">
      {/* Savoirs - S1, S2... */}
      {selectedSavoirs && selectedSavoirs.map((question, sIdx) => (
        <div key={`s-${sIdx}`} className="flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border border-sky-200">
          <span className="text-[10px] font-bold text-sky-700">S{sIdx + 1}</span>
          <div className="flex gap-0.5">
            {question.comp.map((c, cIdx) => {
              const pourcentage = calculerPourcentageReussiteEvalClasse(eleves, question.savoir, c);
              const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
              return (
                <span key={cIdx} className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
                  {pourcentage}%
                </span>
              );
            })}
          </div>
        </div>
      ))}

      {/* Automatismes - A1, A2... */}
      {selectedAutomatismes.length > 0 && selectedAutomatismes.map((question, idx) => {
        const pourcentage = calculerPourcentageReussite(eleves, question, "automatismes_filtrées");
        const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
        return (
          <div key={`a-${idx}`} className="flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border border-teal-200">
            <span className="text-[10px] font-bold text-teal-700">A{idx + 1}</span>
            <span className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
              {pourcentage}%
            </span>
          </div>
        );
      })}

      {/* Problèmes - Rdp1, Rdp2... */}
      {selectedProblemes.length > 0 && selectedProblemes.map((question, idx) => {
        const pourcentage = calculerPourcentageReussite(eleves, question, "problèmes_filtrées");
        const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
        return (
          <div key={`rdp-${idx}`} className="flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border border-red-200">
            <span className="text-[10px] font-bold text-red-700">Rdp{idx + 1}</span>
            <span className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
              {pourcentage}%
            </span>
          </div>
        );
      })}

      {/* Lexique - L1, L2... */}
      {selectedLexique.length > 0 && selectedLexique.map((question, idx) => {
        const pourcentage = calculerPourcentageReussite(eleves, question, "lexique_filtrées");
        const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
        return (
          <div key={`l-${idx}`} className="flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border border-purple-200">
            <span className="text-[10px] font-bold text-purple-700">L{idx + 1}</span>
            <span className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
              {pourcentage}%
            </span>
          </div>
        );
      })}

      {/* Compétences - C1, C2... */}
      {selectedCompetences.length > 0 && selectedCompetences.map((question, idx) => {
        const pourcentage = calculerPourcentageReussite(eleves, question, "competences_filtrées");
        const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
        return (
          <div key={`c-${idx}`} className="flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border border-indigo-200">
            <span className="text-[10px] font-bold text-indigo-700">C{idx + 1}</span>
            <span className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
              {pourcentage}%
            </span>
          </div>
        );
      })}

      {/* Compréhension écrite - dynamique par texte */}
      {comprehensionGroups.map((group) =>
        group.questions.map((question, idx) => {
          const pourcentage = calculerPourcentageReussite(eleves, question, group.tache);
          const bgColor = pourcentage >= 70 ? 'bg-green-500' : pourcentage >= 40 ? 'bg-yellow-500' : 'bg-red-500';
          return (
            <div key={`${group.shortLabel}-${idx}`} className={`flex items-center gap-1 bg-white rounded-lg px-2 py-1 shadow-sm border ${group.colors.border}`}>
              <span className={`text-[10px] font-bold ${group.colors.text}`}>{group.shortLabel}{idx + 1}</span>
              <span className={`${bgColor} text-white text-[9px] font-semibold px-1.5 py-0.5 rounded`}>
                {pourcentage}%
              </span>
            </div>
          );
        })
      )}
    </div>

    {/* Panneau détaillé au hover */}
    <div className="absolute left-0 right-0 top-full mt-1 z-50 opacity-0 invisible group-hover/stats:opacity-100 group-hover/stats:visible transition-all duration-300 transform translate-y-2 group-hover/stats:translate-y-0">
      <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-4 max-h-[60vh] overflow-y-auto">
        {/* Savoirs détaillés */}
        {selectedSavoirs && selectedSavoirs.map((question, sIdx) => (
          <div key={`detail-s-${sIdx}`} className="mb-4 last:mb-0">
            <div className="flex items-center gap-2 mb-2 pb-2 border-b border-sky-100">
              <BookOpen className="w-4 h-4 text-sky-600" />
              <span className="text-xs font-bold text-sky-800">S{sIdx + 1} - {question.savoir}</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {question.comp.map((c, cIdx) => {
                const pourcentage = calculerPourcentageReussiteEvalClasse(eleves, question.savoir, c);
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={cIdx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">{c}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Automatismes détaillés */}
        {selectedAutomatismes.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2 pb-2 border-b border-teal-100">
              <Brain className="w-4 h-4 text-teal-600" />
              <span className="text-xs font-bold text-teal-800">Automatismes</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {selectedAutomatismes.map((question, idx) => {
                const pourcentage = calculerPourcentageReussite(eleves, question, "automatismes_filtrées");
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={idx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">A{idx + 1}: {question}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Problèmes détaillés */}
        {selectedProblemes.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2 pb-2 border-b border-red-100">
              <Puzzle className="w-4 h-4 text-red-600" />
              <span className="text-xs font-bold text-red-800">Résolution de problèmes</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {selectedProblemes.map((question, idx) => {
                const pourcentage = calculerPourcentageReussite(eleves, question, "problèmes_filtrées");
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={idx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">Rdp{idx + 1}: {question}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Lexique détaillé */}
        {selectedLexique.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2 pb-2 border-b border-purple-100">
              <Brain className="w-4 h-4 text-purple-600" />
              <span className="text-xs font-bold text-purple-800">Lexique</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {selectedLexique.map((question, idx) => {
                const pourcentage = calculerPourcentageReussite(eleves, question, "lexique_filtrées");
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={idx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">L{idx + 1}: {question}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Compétences détaillées */}
        {selectedCompetences.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2 pb-2 border-b border-indigo-100">
              <Brain className="w-4 h-4 text-indigo-600" />
              <span className="text-xs font-bold text-indigo-800">Compétences</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {selectedCompetences.map((question, idx) => {
                const pourcentage = calculerPourcentageReussite(eleves, question, "competences_filtrées");
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={idx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">C{idx + 1}: {question}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Compréhension écrite détaillée - dynamique par texte */}
        {comprehensionGroups.map((group) => (
          <div key={`detail-${group.shortLabel}`} className="mb-4">
            <div className={`flex items-center gap-2 mb-2 pb-2 border-b ${group.colors.borderDetail}`}>
              <Brain className={`w-4 h-4 ${group.colors.iconColor}`} />
              <span className={`text-xs font-bold ${group.colors.textDetail}`}>Compréhension - {group.texteName}</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {group.questions.map((question, idx) => {
                const pourcentage = calculerPourcentageReussite(eleves, question, group.tache);
                const colorClass = getColorClass(pourcentage);
                return (
                  <div key={idx} className={`flex items-center justify-between p-2 rounded-lg border ${colorClass}`}>
                    <span className="text-xs text-gray-700 truncate flex-1">{group.shortLabel}{idx + 1}: {question}</span>
                    <span className="text-xs font-bold ml-2">{pourcentage}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

  {/* Liste des élèves */}
  <div className="overflow-y-auto max-h-[50vh] xl:max-h-[45vh] 2xl:max-h-[48vh] 3xl:max-h-[50vh] w-full">
                <Droppable droppableId={clusterId.toString()} key={clusterId.toString()}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        minHeight: '120px', // Hauteur minimale fixe pour permettre le drop même sur groupe vide
                        backgroundColor: snapshot.isDraggingOver ? '#f0f9ff' : 'transparent',
                        transition: 'background-color 0.2s ease',
                        border: snapshot.isDraggingOver ? '2px dashed #3b82f6' : '2px dashed transparent',
                        borderRadius: '8px'
                      }}
                    >
                      {eleves && sortStudents(eleves).map((eleve, index) => (
                        <Draggable
                          key={eleve.id.toString()}
                          draggableId={eleve.id.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            
                              style={{
                                ...provided.draggableProps.style,
                                opacity: snapshot.isDragging ? 0.5 : 1,
                                backgroundColor: snapshot.isDragging ? '#e3f2fd' : '',
                              }}
                            >
                              <StudentCard 
                                student={eleve}
                                groupId={clusterId}
                                showDetails={showDetails}
                                isSelected={selectedStudents.has(eleve.id)}
                                onToggleSelect={handleToggleSelect}
                                selectionMode= {selectionMode}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                </div>

        </div>
   ))}

   

          </DragDropContext>
        </div>

        {/* Bouton Transmettre */}
        {(Object.keys(selectedItems).length === Object.keys(clusters).length && Object.keys(clusters).length > 0) && (
          <div className="flex items-center justify-center mt-6 xl:mt-4 2xl:mt-5 3xl:mt-6">
            <button
              onClick={handleSubmit}
              disabled={isLoadingPost}
              className={`flex items-center justify-center gap-2
                px-6 sm:px-8 lg:px-10 xl:px-6 2xl:px-8 3xl:px-10 py-3 sm:py-4 xl:py-2.5 2xl:py-3 3xl:py-4
                text-white font-semibold rounded-xl sm:rounded-2xl
                text-sm sm:text-base lg:text-lg xl:text-sm 2xl:text-base 3xl:text-lg
                transition-colors duration-300
                shadow-lg uppercase tracking-wide
                ${isLoadingPost
                  ? 'bg-gray-400 cursor-not-allowed shadow-gray-400/30'
                  : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 shadow-green-500/30 cursor-pointer'
                }`}
            >
              {isLoadingPost ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Envoi en cours...
                </>
              ) : (
                'Transmettre les groupes'
              )}
            </button>
          </div>
        )}
      </div>
    </main>

    {/* SelectionToolbar - en dehors du header pour éviter les problèmes de z-index */}
    {selectionMode && selectedStudents.size > 0 && (
      <SelectionToolbar
        selectedCount={selectedStudents.size}
        onMoveSelected={(targetGroupId) => {
          moveSelectedStudents(targetGroupId);
        }}
        groups={listGroupes}
        onCancel={() => {
          setSelectedStudents(new Set());
          setSelectionMode(false);
        }}
      />
    )}

    {/* Confirmations (RETOUR, Transmettre) - HORS du header : monté dans son
        contexte d'empilement (relative z-20), le dialog fixed passait SOUS le
        main (z-20 frère suivant), donc sous les cartes de groupes */}
    {ConfirmDialog}
  </div>
    )
}

export default VisuelGroupe;